import { SubGroup } from '@/app/models/financalGroup';
import { createContext, Dispatch, SetStateAction, useContext, useMemo, useState } from 'react';

interface FinancialSubGroupContextType {
  selectedFinancialSubGroup: SubGroup | undefined;
  setSelectedFinancialSubGroup: Dispatch<SetStateAction<SubGroup | undefined>>;
}

const FinancialSubGroupContext = createContext<FinancialSubGroupContextType | undefined>(undefined);

export function FinancialSubGroupProvider({ children }: { children: React.ReactNode }) {
  const [selectedFinancialSubGroup, setSelectedFinancialSubGroup] = useState<SubGroup | undefined>(undefined);
  const contextValue = useMemo(
    () => ({ selectedFinancialSubGroup, setSelectedFinancialSubGroup }),
    [selectedFinancialSubGroup],
  );

  return <FinancialSubGroupContext.Provider value={contextValue}>{children}</FinancialSubGroupContext.Provider>;
}

export const useFinancialSubGroup = () => {
  const context = useContext(FinancialSubGroupContext);
  if (!context) {
    throw new Error('useFinancialGroup deve ser usado dentro de um FinancialGroupContextProvider');
  }
  return context;
};
